module.exports = __webpack_public_path__ + "img/Image.1ff555ea.png";